import { canManageTeam, canManageUsers as roleCanManageUsers, canPostDocuments } from '@finvox/shared/org';
import { useOrg } from '@/contexts/OrgContext';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export function useSettingsAccess() {
  const { orgId, org, periods = [], currentPeriodId } = useOrg();
  const online = useOnlineStatus();
  const role = org?.role;
  const canEdit = Boolean(org && canManageTeam(org.role));
  const canManageUsers = Boolean(org && roleCanManageUsers(org.role));
  const canPost = Boolean(org && role && canPostDocuments(role));
  const currentPeriod = periods.find((p) => p.id === currentPeriodId);
  const periodClosed = currentPeriod?.status === 'closed';

  return {
    orgId,
    org,
    periodId: currentPeriodId,
    currentPeriod,
    periodClosed,
    online,
    canEdit,
    canManageUsers,
    canPost
  };
}
